/**
 * The card and grid every analytics section is built from, so the
 * platform's panels and an extension's panels (handed this component
 * through the ``analyticsPanels`` seam) look the same: two columns,
 * equal heights, a medium-weight title, a caption under it, and an
 * empty state that is one quiet line rather than a tall box.
 */
import { cn } from "../../utils/bem";
import "./AnalyticsPanel.prefix.css";

const block = cn("analytics-panel");

export const AnalyticsGrid = ({ children }) => <div className={cn("analytics-grid").toClassName()}>{children}</div>;

export const AnalyticsPanel = ({ title, subtitle, right, children, empty, span = 1 }) => (
  <section className={block.mod({ "span-2": span > 1 }).toClassName()}>
    <header className={block.elem("head").toClassName()}>
      <div className={block.elem("heading").toClassName()}>
        <h3 className={block.elem("title").toClassName()}>{title}</h3>
        {subtitle && <p className={block.elem("subtitle").toClassName()}>{subtitle}</p>}
      </div>
      {right}
    </header>
    <div className={block.elem("body").toClassName()}>
      {empty ? <div className={block.elem("empty").toClassName()}>{empty}</div> : children}
    </div>
  </section>
);
